/**
 * Glisser-déposer d'une rubrique ou d'un canevas du panneau gauche vers l'édition ou le sommaire
 */

// Type propre à l'application : ni les champs texte ni TinyMCE n'insèrent ce contenu au dépôt
export const RUBRIC_DRAG_TYPE = 'application/x-now-rubric';

export const isRubricDrag = (event) =>
  Array.from(event.dataTransfer?.types || []).includes(RUBRIC_DRAG_TYPE);

/**
 * Emplacement d'insertion sous le pointeur, parmi les descendants de container
 * marqués data-rubric-slot="<id de rubrique>" (dans l'ordre du document).
 * @returns {{ index: number, beforeRubricId: string|null }} beforeRubricId null = en fin de liste
 */
export const getRubricDropTarget = (container, clientY) => {
  const slots = container ? Array.from(container.querySelectorAll('[data-rubric-slot]')) : [];
  const index = slots.findIndex((slot) => {
    const rect = slot.getBoundingClientRect();
    return clientY < rect.top + rect.height / 2;
  });
  return index === -1
    ? { index: slots.length, beforeRubricId: null }
    : { index, beforeRubricId: slots[index].dataset.rubricSlot };
};

/**
 * Insère newRubrics avant la rubrique beforeRubricId (en fin de liste si null ou introuvable)
 * et renumérote les positions.
 */
export const insertRubricsBefore = (rubrics, newRubrics, beforeRubricId = null) => {
  const sorted = [...rubrics].sort((a, b) => a.position - b.position);
  const found = beforeRubricId ? sorted.findIndex((rubric) => rubric.id === beforeRubricId) : -1;
  const index = found === -1 ? sorted.length : found;
  return [...sorted.slice(0, index), ...newRubrics, ...sorted.slice(index)]
    .map((rubric, i) => ({ ...rubric, position: i + 1 }));
};
